import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BackArrow from '../../assets/images/Frame_18177.png';
import FiCamera from '../../assets/images/fi_camera.png';
import FiChevronsRight from '../../assets/images/fi_chevrons-right.png';

const CaptureImagePage = () => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [imageData, setImageData] = useState(null);
    const [isCameraVisible, setIsCameraVisible] = useState(true);
    const navigate = useNavigate();
    const [stream, setStream] = useState(null); // To store the stream for stopping it

    useEffect(() => {
        if (isCameraVisible) {
            const videoElement = videoRef.current;

            // Access the webcam video stream
            navigator.mediaDevices.getUserMedia({ video: true })
                .then((stream) => {
                    setStream(stream); // Save the stream so that we can stop it later
                    if (videoElement) {
                        videoElement.srcObject = stream;
                    }
                })
                .catch((error) => {
                    console.error("Error accessing webcam: ", error);
                });

            return () => {
                // Clean up the video stream when component unmounts or when camera is hidden
                if (videoElement && videoElement.srcObject) {
                    videoElement.srcObject.getTracks().forEach(track => track.stop());
                }
            };
        }
    }, [isCameraVisible]);

    const captureImage = () => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');

        canvas.width = videoRef.current.videoWidth;
        canvas.height = videoRef.current.videoHeight;

        context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL('image/png');
        setImageData(dataURL);
        setIsCameraVisible(false);

        // Stop the video stream after capturing
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
    };

    const retakeImage = () => {
        setImageData(null);
        setIsCameraVisible(true); // Restart the camera
    };

    const handleSubmit = () => {
        navigate('/patient-details', { state: { image: imageData } });
    };

    return (
        <div>
            <div className='flex inline-block'>
                <Link
                    to="/registration-with-adhar"
                    className={`flex w-28 mt-6 ml-4 sm:ml-8 lg:ml-14 px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200`}
                    style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}
                >
                    <img src={BackArrow} alt="Back" className="mr-2" style={{ height: '24px', width: '24px' }} />
                    Back
                </Link>
                <span className='mt-8 ml-4' style={{ fontFamily: 'Roboto', fontSize: '28px', fontWeight: '600', lineHeight: '32.81px' }}>New Registration</span>
            </div>

            <hr className="mt-6 mx-4 sm:mx-8 lg:mx-14 border-t-1 border-gray-300" />

            <div className="flex justify-center mt-6">
                <div className="flex flex-col items-center w-full max-w-sm">
                    <p className='text-[#565661] mb-6' style={{ fontFamily: 'Roboto', fontSize: '24px', fontWeight: '500', lineHeight: '28.13px' }}>Patient Photo</p>

                    {imageData ? (
                        <div className="flex flex-col items-center">
                            <img src={imageData} alt='Patient' className='rounded-xl' />
                            <button
                                onClick={retakeImage}
                                className={`mt-6`}
                                style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}
                            >
                                <span className='underline'>Retake</span>
                            </button>
                            <button
                                onClick={handleSubmit}
                                className={`flex items-center justify-center space-x-2 w-56 mt-6 px-4 py-4 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200`}
                                style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}
                            >
                                <span>Submit</span>
                            </button>
                        </div>
                    ) : (
                        <>
                            {isCameraVisible && (
                                <video ref={videoRef} autoPlay playsInline className='rounded-xl' style={{ width: '100%', maxWidth: '400px', height: 'auto' }} />
                            )}
                            <canvas ref={canvasRef} className="hidden"></canvas>
                            <button
                                onClick={captureImage}
                                className={`flex items-center justify-center space-x-2 w-56 mt-6 px-4 py-4 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200`}
                                style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}
                            >
                                <img src={FiCamera} alt="Capture" className="" />
                                <span>Capture</span>
                            </button>
                        </>
                    )}
                </div>
            </div>

            <div className="flex inline-block justify-end mt-6 mb-6 mr-4 sm:mr-8 lg:mr-14">
                <Link
                    to="/patient-details"
                    className={`flex text-[#565661] text-lg font-semibold`}
                    style={{ fontFamily: 'Roboto', fontSize: '24px', fontWeight: '500', lineHeight: '28.13px' }}
                >
                    Skip <img src={FiChevronsRight} alt='Without Aadhar' className='flex ml-2' />
                </Link>
            </div>
        </div>
    );
}

export default CaptureImagePage;
